/**
 * Отправляет ли этот бот реакции.
 *
 * Реакции ботов существуют, чтобы сетевой матч выглядел живым, а бот —
 * человеком. «Явный» бот честно помечен ботом для всех (см.
 * configs/visibleRankedBots), изображать человека ему незачем — реакций он не
 * шлет никогда.
 *
 * Отдельно от этого сервер и не принял бы их (см.
 * checkIfReactionOnBehalfOfBotAllowed). Так что без этой проверки клиент
 * просто заводил бы таймеры и слал сообщения, которые молча отбрасываются.
 *
 * Бот, которым вручную управляет админ (botControlledByUserId, см.
 * getActingPlayer), сам тоже не пишет и не отвечает: за него говорит админ из
 * своей панели реакций. Молчит, пока стоит пометка, — даже если админ вышел:
 * реакции лишь украшение, а в сети ли админ, клиенту знать не по чему. Сервер
 * от других клиентов реакции за такого бота и не примет.
 */
export const checkIfBotSendsReactions = (player) => Boolean(
  player && player.isBot && !player.isVisibleBot && !player.botControlledByUserId
);
